//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SchoolMileageSettingsDisplayItem } from './SchoolMileageSettingsDisplayItem';
import { SchoolLatePaymentFeeSettingsDisplayItem } from './SchoolLatePaymentFeeSettingsDisplayItem';
import { BalanceDateType, SurchargeType } from './Enums';

export class SchoolAccountingSettingsDisplayItem extends ItemBase {
    DefaultBalanceDate: string | null = null;
    DefaultBalanceDateType: BalanceDateType = BalanceDateType.Today;
    DefaultBalanceDateDayOfMonth: number | null = null;
    DefaultMileageSettings: SchoolMileageSettingsDisplayItem | null = null;
    LateFeeEventCategoryID: string | null = null;
    LatePaymentFeeSettings: SchoolLatePaymentFeeSettingsDisplayItem | null = null;
    LatePaymentFeeType: SurchargeType = SurchargeType.None;
    MembershipFeeCategoryID: string | null = null;
    PaymentMethods: string[] = [];
    SpecifiedBalanceDate: string | null = null;

    constructor(initializer?: Partial<SchoolAccountingSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolAccountingSettingsDisplayItem";
}
